interface HookReturnType {
    mouseDownHandler: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export const useDraggableScroll = (
    draggableEl: HTMLDivElement | null,
    enableDrag = true
): HookReturnType => {
    let pos = { top: 0, left: 0, x: 0, y: 0 };

    if (!draggableEl || !enableDrag) {
        return {
            mouseDownHandler: () => {
                return;
            },
        };
    }

    const mouseDownHandler = function (
        e: React.MouseEvent<HTMLDivElement, MouseEvent>
    ) {
        pos = {
            ...pos,
            // The current scroll
            left: draggableEl.scrollLeft,
            top: draggableEl.scrollTop,
            // Get the current mouse position
            x: e.clientX,
            y: e.clientY,
        };
        draggableEl.style.cursor = 'grabbing';
        draggableEl.style.userSelect = 'none';
        draggableEl.addEventListener('mousemove', mouseMoveHandler);
        draggableEl.addEventListener('mouseup', mouseUpHandler);
        window.addEventListener('mousemove', mouseMoveWindowHandler);
    };

    const mouseMoveWindowHandler = (e: MouseEvent) => {
        if (
            e.clientY < draggableEl.getBoundingClientRect().top ||
            e.clientY > draggableEl.getBoundingClientRect().bottom
        ) {
            window.removeEventListener('mousemove', mouseMoveWindowHandler);
            draggableEl.removeEventListener('mousemove', mouseMoveHandler);
            draggableEl.removeEventListener('mouseup', mouseUpHandler);
        }
    };

    const mouseMoveHandler = function (e: MouseEvent) {
        // How far the mouse has been moved
        const dx = e.clientX - pos.x;
        const dy = e.clientY - pos.y;
        // Scroll the element
        draggableEl.scrollTop = pos.top - dy;
        draggableEl.scrollLeft = pos.left - dx;
        draggableEl.style.cursor = 'grabbing';
        draggableEl.style.userSelect = 'none';
    };
    const mouseUpHandler = function () {
        draggableEl.removeEventListener('mousemove', mouseMoveHandler);
        draggableEl.removeEventListener('mouseup', mouseUpHandler);
        window.removeEventListener('mousemove', mouseMoveWindowHandler);
        draggableEl.style.cursor = 'grab';
        draggableEl.style.removeProperty('user-select');
    };

    return { mouseDownHandler };
};
